import { WaitlistPage } from "./WaitlistPage"
import {
  getCheerWaitlistCsv,
  useCheerWaitlist,
  useDeleteCheerWaitlistSignup,
} from "@/hooks/useComms"

export function CheerWaitlist() {
  return (
    <WaitlistPage
      title="Cheer early-access list"
      purpose="Cheer early access"
      product="Cheer"
      csvPrefix="cheer-waitlist"
      listName="the Cheer early-access list"
      useList={useCheerWaitlist}
      getCsv={getCheerWaitlistCsv}
      useDelete={useDeleteCheerWaitlistSignup}
    />
  )
}
